/**
 * @param min included
 * @param max excluded
 * @return {number} random int between min and max [min, max)
 */
export function getRandomInt(min, max) {
	if (min > max) {
		throw Error("min must not be bigger than max.");
	}
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min) + min);
}
